import {Injectable} from '@angular/core';
import {BackItem, FormDefine} from '../define';
import {ActivatedRoute, Router} from '@angular/router';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class StateService {

  constructor() {

  }
  public state: BackItem[];
  public backwardItem: BackItem;
  private router: Router;
  private activatedRoute: ActivatedRoute;
  private haveBackward: boolean;
  private initializing: boolean;

  private static createBackItem(form: FormDefine, path: string, params: { [key: string]: any }): BackItem {
    return {
      formName: form.name,
      pageIndex: form.pageIndex,
      pageSize: form.pageSize, path,
      searchInfo: form.searchInfo,
      sortInfo: form.sortInfo,
      params
    };
  }

  public applyState(form: FormDefine): void {
    // Wait until initialize completed
    while (this.initializing) {
      // Do nothing
    }
    if (this.backwardItem && form.name === this.backwardItem.formName) {
      const item = this.backwardItem;
      form.searchInfo = item.searchInfo;
      form.pageIndex = item.pageIndex;
      form.sortInfo = item.sortInfo;
      form.pageSize = item.pageSize;
    }
  }

  public getStateParams(): any {
    while (this.initializing) {
      // Do nothing
    }
    if (this.backwardItem) {
      return this.backwardItem.params;
    }
    return null;
  }

  public backward(): void {
    if (this.state && this.state.length > 0) {
      const bi: BackItem = this.state[this.state.length - 1];
      this.router.navigateByUrl(bi.path, {state: {state: this.state, backward: true, params: bi.params}}).then(_ => {
      });
    }
  }

  public isHaveBackward(): any {
    return this.haveBackward;
  }

  public navigate(url: string, form: FormDefine, params: { [key: string]: any }): void {
    let state = this.state;
    if (!state) {
      state = [];
    }

    let bi: BackItem = {
      formName: null,
      pageIndex: 1,
      pageSize: 1,
      searchInfo: null,
      sortInfo: null,
      path: this.router.url,
      params
    };

    if (form) {
      bi = StateService.createBackItem(form, this.router.url, params);
    }
    state.push(bi);
    this.router.navigateByUrl(url, {state: {state, backward: false, params}}).then(_ => {
    });
  }

  /**
   * Get parameter from navigated page
   * @param route Activated route
   * @param loaded Callback function to get result
   * @param backward If true, get params just if have a backward navigation
   */
  public params(route: ActivatedRoute, loaded: (params: {[key: string]: any}) => void, backward = false): void {
    const state$ = route.paramMap
      .pipe(map(() => window.history.state));
    if (backward) {
      state$.subscribe(info => {
        if (info.backward && info.state && info.state.length > 0) {
          loaded(info.state[info.state.length - 1].params);
        }
      });
    }else{
      state$.subscribe(info => {
        loaded(info.params);
      });
    }
  }

  public backwardParams(route: ActivatedRoute, loaded: (params) => void): void {
    this.params(route, loaded, true);
  }

  public init(router: Router, activatedRoute: ActivatedRoute): void {
    this.initializing = true;
    this.state = [];
    this.haveBackward = false;
    this.backwardItem = null;

    this.router = router;
    this.activatedRoute = activatedRoute;

    // const state$ =  StateService.router.events.pipe(
    //   filter(e => e instanceof NavigationStart),
    //   map(() => StateService.router.getCurrentNavigation().extras.state)
    // );

    const state$ = this.activatedRoute.paramMap
      .pipe(map(() => window.history.state));

    state$.subscribe(info => {
      if (info.backward && info.state && info.state.length > 0) {
        this.backwardItem = info.state.pop();
      }
      this.state = info.state;
      if (this.state && this.state.length > 0) {
        this.haveBackward = true;
      }
      this.initializing = false;
    });
  }
}
